var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 50,
    viewBox: "0 0 60 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2012 4.65602C60.2663 3.59075 60.2663 1.86385 59.2012 0.798574C58.1361 -0.266153 56.4093 -0.266153 55.3443 0.798574L33.5261 22.617C32.461 23.6821 32.461 25.4089 33.5261 26.4739L55.3443 48.2921C56.4093 49.3572 58.1361 49.3572 59.2012 48.2921C60.2663 47.2271 60.2663 45.5003 59.2012 44.4352L39.3115 24.5455L59.2012 4.65602ZM26.4739 4.65602C27.539 3.59075 27.539 1.86385 26.4739 0.798574C25.4088 -0.266153 23.682 -0.266153 22.617 0.798574L0.798542 22.617C-0.266185 23.6821 -0.266185 25.4089 0.798542 26.4739L22.617 48.2921C23.682 49.3572 25.4088 49.3572 26.4739 48.2921C27.539 47.2271 27.539 45.5003 26.4739 44.4352L6.58417 24.5455L26.4739 4.65602Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadLeft);
export default __webpack_public_path__ + "static/media/load-left.0fce40c3ef9f1b6023a0b03d61cb8e31.svg";
export { ForwardRef as ReactComponent };